import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const securityPolicyTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Security Policy',
  key: 'securityPolicy',
  passwordSettings: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['minimumPasswordLength', 'uniquePasswordHistoryCount', 'passwordExpirationDays', '$empty'],
          ['requireUppercase', 'requireLowercase', 'requireNumber', 'requireSymbol'],
          ['allowNumericSequences', 'maxConsecutiveCharacters', 'allowPasswordUsernameMatch', 'allowCurrentPasswordReuse']
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      minimumPasswordLength: {
        label: 'Minimum Password Length (6-16)',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  6,
                  16
                ]
              ],
            }
          ],
        },
      },
      uniquePasswordHistoryCount: {
        label: 'Number of Last Unique Password (0-24)',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  24
                ]
              ],
            }
          ],
        },
      },
      passwordExpirationDays: {
        label: 'Password Expiration (1-365 days)',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  365
                ]
              ],
            }
          ],
        },
      },
      requireUppercase: {
        type: 'checkbox',
        label: 'Include at least one uppercase letter',
        initial: false
      },
      requireLowercase: {
        type: 'checkbox',
        label: 'Include at least one lowercase letter',
        initial: false
      },
      requireNumber: {
        type: 'checkbox',
        label: 'Include at least one number',
        initial: false
      },
      requireSymbol: {
        type: 'checkbox',
        label: 'Include at least one symbol',
        initial: false
      },
      allowNumericSequences: {
        type: 'checkbox',
        label: 'Cannot be in numeric sequence',
        initial: false
      },
      maxConsecutiveCharacters: {
        type: 'checkbox',
        label: 'No more than 2 consecutive occurrence of the same letter, number or symbol',
        initial: false
      },
      allowPasswordUsernameMatch: {
        type: 'checkbox',
        label: 'Cannot be same as username',
        initial: false
      },
      allowCurrentPasswordReuse: {
        type: 'checkbox',
        label: 'Cannot be same as current password',
        initial: false
      },
    },
  },
  accountLockoutSettings: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          [
            'enableAccountLockout',
            'maxAccountLoginAttempts',
            'accountLoginAttemptsIntervalMinutes',
            'accountLockDurationMinutes'
          ],
          [
            'applyToSystemAdminAccount',
            '$empty',
            '$empty',
            '$empty'
          ]
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      enableAccountLockout: {
        type: 'checkbox',
        label: 'Enable Account Lockout',
        initial: false
      },
      maxAccountLoginAttempts: {
        label: 'Max Consecutive Failed Login Attempts (1-10)',
        type: 'text',
        initial: '',
        hide: 'false',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  10
                ]
              ],
            }
          ],
        },
      },
      accountLoginAttemptsIntervalMinutes: {
        label: 'Failed Login Attempt Time Interval (1-1440 mins)',
        type: 'text',
        initial: '',
        hide: 'false',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  1440
                ]
              ],
            }
          ],
        },
      },
      accountLockDurationMinutes: {
        label: 'Account Locked Duration (1-1440 mins)',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  1440
                ]
              ],
            }
          ],
        },
      },
      applyToSystemAdminAccount: {
        type: 'checkbox',
        label: 'Apply to \'sysadm\' Account',
        initial: false,
        hide: 'false'
      },
    },
  },
  ipAddressBlockingSettings: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          [
            'enableIpAddressBlocking',
            'maxIpAddressLoginAttempts',
            'ipAddressLoginAttemptsIntervalMinutes',
            'ipAddressBlockDurationMinutes'
          ],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      enableIpAddressBlocking: {
        type: 'checkbox',
        label: 'Enable IP Address Blocking',
        initial: false,
        hide: 'false'
      },
      maxIpAddressLoginAttempts: {
        label: 'Max Consecutive Failed Login Attempts (1-20)',
        type: 'text',
        initial: '',
        hide: 'false',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  20
                ]
              ],
            }
          ],
        },
      },
      ipAddressLoginAttemptsIntervalMinutes: {
        label: 'Failed Login Attempt Time Interval (1-1440 mins)',
        type: 'text',
        initial: '',
        hide: 'false',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  1440
                ]
              ],
            }
          ],
        },
      },
      ipAddressBlockDurationMinutes: {
        label: 'IP Address Blocked Duration (1-1440 mins)',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'Interval',
              intervals: [
                [
                  1,
                  1440
                ]
              ],
            }
          ],
        },
      },
    },
  },
};
